import Alpine from "alpinejs";
import { AlpineComponentTryba } from '../../scripts/alpine/include/global';
// import {sendPageDatas} from "../../scripts/alpine/include/taggage";

document.addEventListener('alpine:init', () => {
    Alpine.data('initFaq', (): AlpineComponentTryba => {
        return {
            active: {
                'gamme':null,
                'title': null
            },
            init() {
                this.active['gamme'] = 'all'
                this.active['title'] = 'Toutes les questions'

                // sendPageDatas(
                //     {
                //         'slot1':'test',
                //         'slot2':'test2',
                //         'slot3':'test3',
                //     },
                //     {
                //         'categ':'faq'
                //     }
                // )
            },
            activeFilter(item:string, title:string, type:string) {
                this.active[type] = item
                this.active['title'] = title
            }
        }
    })
})
